// App
import { authClient, getKeycloakInitOptions } from '@neptune/shared/core-auth-domain';

authClient.init(getKeycloakInitOptions()).then((authenticated) => {
  authenticated ? redirectToApp() : redirectToKeycloak();
});

function redirectToKeycloak() {
  const registerUrl = authClient.createRegisterUrl({
    redirectUri: `${window.location.origin}/-/onboarding`,
  });

  window.location.replace(registerUrl);
}

function redirectToApp() {
  window.location.replace('/');
}
